import { Dialog } from 'primereact/dialog';
import React from 'react';
import lightning from '../../resources/images/lightning.png';
import BaseButton from '../form/BaseButton.jsx';
import IconCloseFull from '../images/IconCloseFull.jsx';
import { useDeleteCalendarMeetingMutation } from '../../api/calendar.js';
import { useNavigate } from 'react-router-dom';
import { useErrorToast } from '../../hooks/useToast.jsx';

const MeetingDeleteConfirmation = React.memo(({ deleteVisible, setDeleteVisible, meeting }) => {
    const [deleteCalendarMeeting, { isLoading }] = useDeleteCalendarMeetingMutation();
    const navigate = useNavigate();
    const hideDialog = () => {
        setDeleteVisible(false);
    };

    const confirmDelete = async (deleteSeries) => {
        try {
            await deleteCalendarMeeting({ id: meeting.id, deleteSeries }).then((apiResponse) => {
                if (apiResponse.data?.success) {
                    navigate('/calendar');
                } else {
                    useErrorToast(apiResponse.data?.message);
                }
            });
        } catch (error) {
            console.error('Failed to delete meeting:', error);
        }

        setDeleteVisible(false);
    };

    if (!deleteVisible) return null;

    return (
        <Dialog
            className='rounded-4xl'
            visible={deleteVisible}
            style={{ width: '400px' }}
            breakpoints={{ '420px': '320px' }}
            onHide={hideDialog}
            content={() => (
                <div className='flex flex-col justify-center items-center px-6 py-8 pt-12 bg-white rounded-4xl'>
                    <button onClick={hideDialog} className='absolute top-6 right-6'>
                        <IconCloseFull className='fill-theme1-text5' />
                    </button>
                    <img alt='' src={lightning} className='w-[46px] h-[105px] mb-[16px]' />
                    <div className='text-theme1-primary text-[22px] mb-[30px] text-center leading-tight'>
                        <span className={'font-bold mb-[16px]'}>Confirm delete!</span>
                        <p>
                            Are you sure you want to delete <strong>{meeting.title}</strong> or its occurrences? This
                            process is irreversible!
                        </p>
                    </div>
                    <div className='w-full'>
                        <BaseButton
                            className='btn-primary mx-auto'
                            onClick={() => confirmDelete(false)}
                            textValue={'Delete this meeting'}
                            disabled={isLoading}
                        />
                        {meeting.is_recurrent && (
                            <BaseButton
                                className='btn-primary mx-auto mt-6'
                                onClick={() => confirmDelete(true)}
                                textValue={'Delete all meetings in the series'}
                                disabled={isLoading}
                            />
                        )}

                        <BaseButton className='btn-red-outline mx-auto mt-6' textValue='Cancel' onClick={hideDialog} />
                    </div>
                </div>
            )}
        ></Dialog>
    );
});

MeetingDeleteConfirmation.displayName = 'MeetingDeleteConfirmation';

export default MeetingDeleteConfirmation;
